import { useSeo } from '@/hooks/useSeo';

export default function TerminiPage() {
  useSeo({
    title: 'Termini e Condizioni',
    description: "Termini e condizioni di vendita Ciro Gallotti: ordini, pagamenti, spedizioni, diritto di recesso, garanzia legale.",
    path: '/termini',
  });

  return (
    <article className="bg-ivory pt-24 md:pt-28" data-testid="termini-page">
      <header className="px-6 md:px-12 lg:px-16 py-12 md:py-20 hairline-b">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-4 mb-5">
            <div className="w-12 h-px bg-bordeaux" />
            <p className="text-eyebrow text-bordeaux">Termini di Vendita</p>
          </div>
          <h1 className="font-display text-h1 text-ink">
            Termini e <span className="italic">Condizioni</span>
          </h1>
          <p className="mt-6 text-ink/65 leading-relaxed">
            Ultimo aggiornamento: febbraio 2026. Codice del Consumo (D.lgs. 206/2005) e normativa vigente.
          </p>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-16 py-12 md:py-16 space-y-12 text-ink/80 leading-relaxed">
        <section>
          <h2 className="font-display text-h3 text-ink mb-4">1. Venditore</h2>
          <p>
            I prodotti commercializzati sul sito cirogallotti.com sono venduti da
            {' '}<strong>Ciro Gallotti</strong> (P.IVA 11025931210), Via Chiaia 138, 80121 Napoli (Italia).
            Contatti: <a href="mailto:cirogallotti81@libero.it" className="text-bordeaux hover:underline">cirogallotti81@libero.it</a>
            {' '}— tel. <a href="tel:+393336450082" className="text-bordeaux hover:underline">+39 333 645 0082</a>.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">2. Ordini e accettazione</h2>
          <p>
            L'invio dell'ordine tramite il checkout costituisce proposta d'acquisto. Il contratto si
            considera concluso solo al momento della <strong>conferma scritta</strong> da parte del
            Venditore (email di conferma). Ci riserviamo di non accettare ordini in caso di
            indisponibilità del prodotto, errori manifesti nel prezzo o sospetta frode.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">3. Prezzi e pagamenti</h2>
          <p>
            I prezzi sono espressi in Euro, <strong>IVA inclusa</strong>. I pagamenti sono gestiti
            tramite Stripe Payments Europe Ltd. e supportano carte di credito/debito e altri metodi
            elettronici. Nessun dato della carta è memorizzato sui nostri server.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">4. Spedizione e consegna</h2>
          <ul className="mt-2 space-y-2 list-disc pl-6">
            <li>Spedizione <strong>gratuita</strong> in tutta Italia per ogni ordine.</li>
            <li>Consegna assicurata entro <strong>2-3 giorni lavorativi</strong> dalla conferma.</li>
            <li>Spedizioni internazionali su richiesta, con quotazione personalizzata.</li>
            <li>Il rischio di perdita o danneggiamento si trasferisce al consumatore alla consegna.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">5. Diritto di recesso</h2>
          <p>
            Ai sensi degli artt. 52-58 del Codice del Consumo, hai diritto di recedere dall'acquisto
            entro <strong>14 giorni</strong> dalla ricezione del prodotto, senza dover fornire alcuna
            motivazione. Per esercitare il recesso invia comunicazione scritta a
            {' '}<a href="mailto:cirogallotti81@libero.it" className="text-bordeaux hover:underline">cirogallotti81@libero.it</a>{' '}
            indicando l'ordine e restituisci il prodotto integro, completo della confezione originale
            e del certificato di autenticità.
          </p>
          <p className="mt-3">
            Il rimborso avverrà entro 14 giorni dal ricevimento del reso, con lo stesso metodo di
            pagamento utilizzato. <strong>Le spese di restituzione sono a carico del consumatore</strong>,
            salvo difetti del prodotto.
          </p>
          <p className="mt-3 text-small text-muted">
            Esclusioni: il recesso non si applica ai gioielli realizzati su misura o personalizzati su richiesta del cliente (art. 59 lett. c Cod. Cons.).
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">6. Garanzia legale di conformità</h2>
          <p>
            Tutti i prodotti sono coperti dalla garanzia legale di conformità di <strong>24 mesi</strong>
            (artt. 128-135 Codice del Consumo). In caso di difetto, hai diritto alla riparazione o
            sostituzione gratuita; qualora ciò non sia possibile, alla riduzione del prezzo o alla
            risoluzione del contratto. Per attivare la garanzia contattaci all'indirizzo
            {' '}<a href="mailto:cirogallotti81@libero.it" className="text-bordeaux hover:underline">cirogallotti81@libero.it</a>.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">7. Certificato di autenticità</h2>
          <p>
            Ogni gioiello è accompagnato da un certificato di autenticità a vita firmato dal Maestro,
            che attesta la qualità dei materiali (oro 18 kt, diamanti certificati, pietre preziose
            tracciabili) e l'origine artigianale partenopea.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">8. Proprietà intellettuale</h2>
          <p>
            Tutti i contenuti del sito (immagini, testi, design, loghi) sono di proprietà esclusiva
            di Ciro Gallotti e tutelati dalle leggi sul diritto d'autore. È vietata la riproduzione,
            anche parziale, senza autorizzazione scritta.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">9. Foro competente e ODR</h2>
          <p>
            Per qualsiasi controversia è competente, in via esclusiva, il Foro del consumatore.
            In alternativa, è disponibile la piattaforma europea di risoluzione delle controversie
            online (ODR):{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-bordeaux hover:underline">
              ec.europa.eu/consumers/odr
            </a>.
          </p>
        </section>

        <section>
          <h2 className="font-display text-h3 text-ink mb-4">10. Legge applicabile</h2>
          <p>I presenti termini sono regolati dalla legge italiana.</p>
        </section>
      </div>
    </article>
  );
}
